// src/pages/EventDetail.tsx

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Event } from './types';
import { instance } from '../../api/axiosInstance';
import axios from 'axios';
import { IoIosArrowBack } from 'react-icons/io';
import { t } from 'i18next';

const EventDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvent = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await instance.get<Event>(`/api/events/${id}`);
        setEvent(response.data);
      } catch (err) {
        if (axios.isAxiosError(err)) {
          setError(
            err.response?.data?.message ||
              '이벤트를 불러오는 중 오류가 발생했습니다.'
          );
        } else {
          setError('이벤트를 불러오는 중 예상치 못한 오류가 발생했습니다.');
        }
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEvent();
    }
  }, [id]);

  if (loading) return <p>로딩 중...</p>;
  if (error) return <p className="text-red-500">{error}</p>;
  if (!event) return <p>이벤트를 찾을 수 없습니다.</p>;

  return (
    <div className="max-w-[1440px] mx-auto p-4 mt-[130px] pb-[100px]  h-screen">
      <div className="bg-white w-[40px] h-[40px] text-xl mobile:text-sm mobile:w-[32px] mobile:h-[32px] border border-gray-200 rounded-full shadow-lg hover:shadow-xl flex items-center justify-center">
        <IoIosArrowBack
          onClick={() => navigate(-1)}
          className="text-[#4d6786] cursor-pointer"
        />
      </div>
      <div className='flex items-center gap-3 mt-[70px] mobile:mt-[34px]'>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={30}
          height={30}
          viewBox="0 0 256 256"
        >
          <circle cx={128} cy={128} r={128} fill="#f05537"></circle>
          <path
            fill="#fff"
            d="M117.475 82.729c19.297-4.288 38.595 3.574 49.315 18.582L81.502 120.61c2.859-18.345 16.676-33.592 35.973-37.88m49.792 70.756c-6.671 9.768-16.915 16.677-28.589 19.297c-19.297 4.288-38.832-3.573-49.553-18.82l85.527-19.298l13.818-3.097l26.682-5.956c-.238-5.717-.953-11.435-2.144-16.914c-10.72-45.98-57.653-74.806-104.586-64.086s-76.235 56.462-65.276 102.68s57.653 74.806 104.585 64.085c27.636-6.194 49.077-24.776 60.036-48.361z"
          ></path>
        </svg>
        <p className=" text-[#f05537] text-xl mobile:text-lg Pretendard-Bold tracking-wide">
        {event.isNew ? '새로운 이벤트' : '이벤트'}
      </p>
      </div>


      <h1 className="text-4xl text-[#141414] Pretendard-Bold mobile:text-lg tracking-wide mt-[32px] mobile:mt-6 w-full border-t  border-t-[#00000071] pt-6 mobile:pt-4">
        [{event.title}]
      </h1>
      <p className="mt-3 text-[#afafaf] mobile:text-xs Pretendard-Regular tracking-wide text-sm font-normal border-b  border-b-[#0000002c] pb-6 mobile:pb-4">
        이벤트 기간: {event.startDate} - {event.endDate}
      </p>
      <div className='my-[24px] mobile:my-4'>
      {event.rewardStartDate && event.rewardEndDate && (
        <p className=" text-[#141414] text-base mobile:text-sm Pretendard-Regular tracking-wide">
          보상 수령 기간 &nbsp;|&nbsp; {event.rewardStartDate} - {event.rewardEndDate}
        </p>
      )}
            {/* <img
        src={`${process.env.REACT_APP_API_BASE_URL}${event.imageUrl}`}
        alt={event.title}
        className="w-full h-auto object-cover my-[24px]"
      /> */}
      </div>

      <p>{event.content}</p>

      {/* 보상 수령 기간을 rewardStartDate와 rewardEndDate로 표시 */}

    </div>
  );
};

export default EventDetail;
